import React from "react";
import Header_m from '../header/Header.js';
import PictureBanner from "../Banner/PictureBanner.js";
import FreeQuoteBlock from '../Home/FreeQuote.js';
import FreeQuoteBlockLarge from "../Home/FreeQuoteLarge.js";
import Footer_m from '../footer/Footer.js';

import vegasHome from '../../img/banners/vegasHome.jpg';
import ServiceList from "../Template/ServiceList.js";


import logoHeader from '../../img/logo/Logo_black.png';

let services = ["Concrete", "Stone Work", "Remodel", "Landscaping", "Yards"];
const Home = () => {
    return (
        <div>
            {/* <Header_m></Header_m> */}

            {/* Add container class to put image in the middle with padding */}
            <div className="container">
                <PictureBanner picture={vegasHome}></PictureBanner>
              

            {/* For Large Screens */}
                <div class="row show-on-large hide-on-med-and-down">

                    <div class="col s12">
                        <div class="card">

                            <div class="col s6">
                                <div class="" >
                                    <ServiceList class="col s5 pull-s7" itemList={services} Title="Services"></ServiceList>
                                </div>
                            </div>

                            <div class="col s6">
                                <FreeQuoteBlockLarge></FreeQuoteBlockLarge>
                            </div>
                        </div>
                    </div>
                </div>

                {/* For small Screens */}
                <div class="hide-on-large-only">

                    <div class="">
                        <div class="card">

                            <div class="col s12">
                                <div class="" >
                                    <ServiceList class="col s5 pull-s7" itemList={services} Title="Services"></ServiceList>
                                </div>
                            </div>

                            <div class="col s12">
                                <FreeQuoteBlock></FreeQuoteBlock>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <div class="container">


            </div>

            <Footer_m></Footer_m>
        </div>

    )
}

export default Home;